import { render } from "./index.vue?vue&type=template&id=66fa4f4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=66fa4f4a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fa4f4a"],['__file',"src/views/order/apartment/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66fa4f4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66fa4f4a', __exports__)) {
    console.log('reload')
    api.reload('66fa4f4a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=66fa4f4a&scoped=true", () => {
    console.log('re-render')
    api.rerender('66fa4f4a', render)
  })

}


export default __exports__